import { render, staticRenderFns } from "./HeaderBeamerButton.vue?vue&type=template&id=48009f0b&scoped=true"
import script from "./HeaderBeamerButton.vue?vue&type=script&lang=js"
export * from "./HeaderBeamerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48009f0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48009f0b')) {
      api.createRecord('48009f0b', component.options)
    } else {
      api.reload('48009f0b', component.options)
    }
    module.hot.accept("./HeaderBeamerButton.vue?vue&type=template&id=48009f0b&scoped=true", function () {
      api.rerender('48009f0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderBeamerButton.vue"
export default component.exports